export default [

     {
          path: '/system-configure',
          name: 'SystemConfigure',
          component: () => import("@/views/Page/SystemConfigure/SystemConfigure.vue"),
           meta: {
               title: '#Default# | SystemConfigure',
          },
     }
];